import { render, staticRenderFns } from "./surface_post_author.vue?vue&type=template&id=7f073adb&scoped=true&"
import script from "./surface_post_author.vue?vue&type=script&lang=js&"
export * from "./surface_post_author.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_author.vue?vue&type=style&index=0&id=7f073adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f073adb",
  null
  
)

export default component.exports